import {
  DescriptionOutlined,
  FolderOutlined,
  HandymanOutlined,
  PeopleAltOutlined
} from '@mui/icons-material';

export const BACKSPACE_SYSTEM = [
  {
    name: 'Project Management',
    shortName: 'project',
    description: 'Register new project • Update project phase',
    url: `${process.env.REACT_APP_PROJECT_REGISTER_WEB_URL}`,
    icon: <FolderOutlined color="primary" />
  },
  {
    name: 'Document Management',
    shortName: 'document',
    description: 'Plan document • Send document to review',
    url: `${process.env.REACT_APP_DOCUMENT_MANAGEMENT_WEB_URL}`,
    icon: <DescriptionOutlined color="primary" />
  },
  {
    name: 'User Management',
    shortName: 'user',
    description: 'Add new member • Manage permissions',
    url: `${process.env.REACT_APP_USER_MANAGEMENT_WEB_URL}`,
    icon: <PeopleAltOutlined color="primary" />
  }
];
